import type { BrowserStorageType } from './_api.type';
import type { BrowserStorage, BrowserStorageStoreName, BrowserStorageStorePath } from './_storage.type';

import api from './_api';

/**
 * Create BrowserStorage.
 *
 * @template TData Data type.
 * @param {BrowserStorageType} type Storage type.
 * @param {BrowserStorageStoreName} store Store name.
 * @param {BrowserStorageStorePath} path Store path.
 *
 * @returns {BrowserStorage<TData>} BrowserStorage.
 */
export default function createBrowserStorage<TData>(
  type: BrowserStorageType,
  store: BrowserStorageStoreName,
  path: BrowserStorageStorePath,
): BrowserStorage<TData> {
  const key = `${store}/${path}`;

  return {
    storage: api.getStorage(type),

    get: () => api.get(type, key),

    set: (value) => api.set(type, key, value),

    remove: () => api.remove(type, key),
  };
}
